import { CoreIcon } from '../core-icon';
import downloadCircleFillSVG from '../../assets/icons/download-circle-fill.svg';
import type { IconProps } from '../core-icon';

export const DownloadCircleFillIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={downloadCircleFillSVG} {...props} />;
};
